<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title">
        <span>
          {{tab_name}}
        </span>
        <button *ngIf="query" (click)="toggleQueryBox()" class="btn btn-link p-0 eye-btn">
          <i class="bi" [matTooltip]="showQueryBox ? 'Hide Query' : 'View Query'"
            [ngClass]="showQueryBox ? 'bi-eye-slash' : 'bi-eye'"
            matTooltipPosition="above">
          </i>
        </button>
      </div>
  
      <div *ngIf="showQueryBox && query" class="alert alert-info query-alert" role="alert">
        {{ query || 'No query found' }}
      </div>
    </div>
  </div>
  
  <div class="row">

    <div class="col-12" style="margin:10px;">
      <div *ngIf=" (tabs$ | async)?.search_type=='company'">
        This page provides a closer look at what the company is focusing on in its innovation activity. The technology footprint graph displays the breakdown of the output over various technology areas over time to highlight focus areas and changes in innovation strategy. The Recent Innovation Activity table provides a closer look on the innovation activity of the last 12 months.


      </div>

      <div *ngIf=" (tabs$ | async)?.search_type=='theme'">
        This page provides a closer look at sub-fields of the technological area. The technology footprint graph displays the breakdown of the output over various technology areas over time to highlight focus areas and changes in innovation strategy. The Recent Innovation Activity table provides a closer look on the innovation activity of the last 12 months.


      </div>
    </div>

    <div class="col m-10">
      <div class="card keywords">
        <h3>Tech Footprint Over Time (10y)</h3>
        <div class="card-content">
          <div class="alert alert-danger" role="alert" *ngIf="footprint_data_loading_failed">
            

            <p>
              Unfortunately, we weren't able to load the data. Please try again later, or for more assistance, please
              contact
              <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
            </p>
          </div>
          
          <div class="empty-state" *ngIf="showFootprintNoDataFound">
          <div class="empty-state-content">
            <i class="bi bi-search empty-state-icon"></i>
            <h4>No Technology Footprint Available</h4>
            <p>There haven't been any inventions published in the last 10 years to generate a technology footprint graph.
            </p>
          </div>
        </div>   
          <div class="spinner-border text-primary" role="status"
            *ngIf="footprintData.length==0 && !footprint_data_loading_failed && !showFootprintNoDataFound">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div *ngIf="showTechnologyFootprint">
            <plotly-plot [data]="techFootprintGraph.data" [layout]="techFootprintGraph.layout"></plotly-plot>
          </div>
        </div>
      </div>
    </div>




    <div class="col m-10">
      <div class="card keywords">

        <h3>Recent Innovation Activity (12m)</h3>
        <div class="card-content">
          <div class="alert alert-danger" role="alert" *ngIf="footprint_detailed_data_loading_failed">
            <p>
              Unfortunately, we weren't able to load the data. Please try again later, or for more assistance, please
              contact
              <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
            </p>
          </div>
          
          <div class="empty-state" *ngIf="showDetailedNoDataFound">
            <div class="empty-state-content">
              <i class="bi bi-search empty-state-icon"></i>
              <h4>No Recent Innovation Activity</h4>
              <p>  There haven't been any inventions published in the last 12 months to display recent innovation activity.
              </p>
            </div>
          </div>
          
          
          <div class="spinner-border text-primary" role="status"
            *ngIf="footprint_detailed_data.length==0 && !footprint_detailed_data_loading_failed && !showDetailedNoDataFound">
            <span class="visually-hidden">Loading...</span>
          </div>
          <table class="table   table-hover table-condensed " *ngIf="footprint_detailed_data.length>0">
            <thead>
              <tr style="background-color: #96c242;">
                <th>Techfield</th>
                <th>Absolute Growth (12m)</th>
                <th>Footprint Percentage (12m)</th>
                <th>Quality (12m)</th>
                <th scope="col" *ngIf="search_type=='company'">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of footprint_detailed_data | paginate: {id:'pag_2', itemsPerPage: 8, currentPage: paginator_2_page }">
                <td>{{item.tf}}</td>
                <td>{{item.invention_count}}</td>
                <td>{{item.invention_count_percentage | nullableNumber: '1.1-1'}} %</td>
                <td>
                  {{item.quality_average | nullableNumber:'1.1-1'}}
                </td>
                <td *ngIf="search_type=='company'">
                  <div class="action-buttons" *ngIf="search_type=='company'">
                 
                    <button class="btn search-button"  *ngIf="search_type=='company'" class="btn company-popup-button" style="background-color: #6c757d;margin-right:10px;"
                      (click)="openCompanyPopup(item.tf)" matTooltip="View Company Details">
                      <i class="bi bi-search" style="color: white; font-size: 16px;"></i>
                    </button>
                    <button class="btn search-button" (click)="submitTheme(item.tf)" matTooltip="Open Theme in New Tab">
                      <i class="bi  bi-box-arrow-up-right" style=" color: rgb(4, 0, 0);font-size: 16px;"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination-controls id="pag_2" [maxSize]="5" (pageChange)="paginator_2_page = $event"
            style="align-items: flex-start;" *ngIf="footprint_detailed_data.length>0">
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>